import { PermissionCategory } from './../../enums/permission-category.enum';

import { CorporateRoleDto } from './../../models/role/corporate-role.dto';
export const corporateRolesMock: CorporateRoleDto[] = [
  {
    id: 'c3e5f607-8192-4ca3-9d04-5e6f708192a3',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    name: 'Corporate Admin',
    description: 'Full access to corporate-level administration features.',
    isActive: true,
    isDefault: true,
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2025-01-10T18:45:00Z',
    permissions: null
  },
  {
    id: 'd4f60718-92a3-4db4-8e05-6f708192a3b4',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    name: 'Billing Manager',
    description: 'Access to billing, invoices, and subscription management.',
    isActive: true,
    isDefault: false,
    createdAt: '2024-06-20T14:10:00Z',
    updatedAt: null,
    permissions: [
      {
        id: 'e5f70829-a3b4-4ec5-9f06-708192a3b4c5',
        name: 'Billing Manager',
        description:
          'Access to billing, invoices, and subscription management.',
        category: PermissionCategory.Billing,
        isActive: true,
        createdAt: '2024-06-20T14:10:00Z',
        updatedAt: null
      }
    ]
  }
];
